import AppBar from "@mui/material/AppBar";
import Drawer from "@mui/material/Drawer";
import styled from "@mui/material/styles/styled";
import Toolbar from "@mui/material/Toolbar";

import { Column } from "@rui/Stack";

export const NAV_BAR_Z_INDEX = 1600;

export const OFFSET_NAV_SPACING = "56px";

export const MobileAppBar = styled(AppBar)(({ theme }) => ({
  backgroundColor: "white",
  zIndex: NAV_BAR_Z_INDEX,
  boxShadow: "0px 8px 24px 0px rgba(0, 0, 0, 0.10)",
  padding: theme.spacing(1, 2),
  height: OFFSET_NAV_SPACING,
  justifyContent: "center",
}));

export const MobileNavDrawer = styled(Drawer)({
  zIndex: NAV_BAR_Z_INDEX + 1,
});

export const MobileNavDrawerOuterContent = styled(Column)(({ theme }) => ({
  backgroundColor: theme.palette.overlay.primary[12],
  height: "100%",
  minWidth: "297px",
  padding: theme.spacing(0, 3),
}));

export const MobileToolbar = styled(Toolbar)({
  padding: 0,
  minHeight: "fit-content !important",
  justifyContent: "space-between",
});
